export default () => 
  `<div class="content"> 
   Contact your local building department to obtain maximum frost depth in the region 
  </div>
`;
